import { getDocumentElement, getDocumentElements } from "./Utils/Utils";

/**
 * Create the error message observer
 * 
 * @param       {object}        options
 * 
 * @returns     {void}
 */
const CreateErrorMessage = options => {
    const Field = getDocumentElement(options.selectors.field);
    const Errors = getDocumentElements(options.selectors.error);

    /**
     * Toggle the given errors depending on the field value.
     * 
     * @param   {integer}       value 
     * 
     * @returns {void}
     */
    const __toggleError = value => {
        const Hide = value.length > 0;

        Errors.forEach(error => {
            Hide
                ? error.classList.remove(options.classes.active)
                : error.classList.add(options.classes.active);
        });
    };

    /**
     * Observe the field value changes using change/input
     * and a setInterval loop.
     * 
     * @param   {HTMLElement}   field 
     * @param   {function}      callback 
     * 
     * @returns {void}
     */
    const __observeFieldValue = (field, callback) => {
        let previousValue = field.value;
        const checkValue = () => {
            if (field.value !== previousValue) {
                previousValue = field.value;
                callback(previousValue);
            }
        };
        const interval = setInterval(checkValue, 100);

        field.addEventListener('input', checkValue);
        field.addEventListener('change', checkValue);

        return () => clearInterval(interval);
    };

    /**
     * Bind the listeners and the setInterval.
     * 
     * @returns {void}
     */
    const __bind = () => {
        __observeFieldValue(Field, (newValue) => {
            __toggleError(newValue);
        });
    };

    /**
     * Init the script.
     * 
     * @returns {void}
     */
    const init = () => {
        if (Field && Errors.length) {
            __bind();
        } else {
            console.warn("Missing field or error elements", { Field, Errors });
        }
    };

    // Expose the init function
    return Object.freeze({ init });
};

export default CreateErrorMessage;